/**
 * Convert a YouTube or Vimeo URL into an embeddable iframe URL.
 * Returns null when the URL isn't recognized so the caller can skip rendering.
 */
export function toEmbedUrl(rawUrl) {
  if (!rawUrl || typeof rawUrl !== 'string') return null;
  const url = rawUrl.trim();
  if (!url) return null;

  // YouTube — handles youtu.be/<id>, youtube.com/watch?v=<id>, /embed/<id>, /shorts/<id>
  const yt = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/))([\w-]{6,15})/i,
  );
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;

  // Vimeo — vimeo.com/<id> or player.vimeo.com/video/<id>
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;

  return null;
}
